import { createSvgIcon, styled } from '@mui/material';

export const ChevronRightIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" d="M6.933 12 6 11.067 9.067 8 6 4.933 6.933 4l4 4-4 4Z" />
  </svg>,
  'ChevronRight',
);

export const ChevronLeftIcon = styled(ChevronRightIcon)({
  transform: 'rotate(180deg)',
});

export const ChevronDownIcon = styled(ChevronRightIcon)({
  transform: 'rotate(90deg)',
});
